import {
  Avatar,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material"
import styles from "./Login.module.css"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useApiService } from "../hooks/Api/useApiService"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import Icn from "../UI/SharieIcn/SharieIcn"
import ShariLogo from "../../assets/images/shariehandslogo.png"
import Spinner from "../UI/Spinner/Spinner"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useSrpAuth } from "../hooks/Api/useSrpLogin"
import useError from "../hooks/Error/useError"

const Login = (props) => {
  const [loading, setLoading] = useState(false)
  const [user_name, setUserName] = useState(null)
  const [password, setPassword] = useState(null)
  const [remember_me, setRememberMe] = useState(false) // State for the checkbox
  const [email, setEmail] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()
  const { BASE_URL, domain } = useApiService()
  const t = useTranslationSharie()
  const { loginSrp } = useSrpAuth()
  const { Error: AlertError, error, success, info } = useError()

  useEffect(() => {
    setRememberMe(localStorage.getItem("user") !== null)
    setUserName(localStorage.getItem("user"))
  }, [])

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  const handleCheckboxChange = (event) => {
    localStorage.setItem("remember_me", event.target.checked)
    setRememberMe(event.target.checked)
  }

  const doLogin = async () => {
    setLoading(true)

    const granted = await loginSrp(user_name, password, setLoading)

    setLoading(false)
    localStorage.setItem("user", user_name)
    if (granted === "You Need To Reset Paswword. click on forgot password") {
      error(granted)

      return
    }
    if (!granted) {
      error("Access Denied, Wrong Details")
    } else {
      success("Just A Moment ... ")

      localStorage.setItem("user", user_name)
      localStorage.removeItem("guest")
      props.setIsAuthenticated(true)
      navigate("/home")
    }
  }

  const handleUserNameChange = (e) => {
    setUserName(e.target.value)
    localStorage.setItem("user", e.target.value)
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const goToSignup = () => {
    navigate("/signup")
  }

  const inputKeyDown = (e) => {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      doLogin()
    }
  }
  const sendResetEmail = async (e) => {
    e.preventDefault()

    const res_email = await fetch(BASE_URL + "users/getuseremail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_name: user_name }),
      credentials: "include",
    })

    if (res_email.ok) {
      const data = await res_email.json()
      setEmail(data?.email)
    } else {
      error("Failed to fetch email: " + res_email.status)
    }

    if (!email) {
      info("You didn't provide an Email. contact us at wishgoods@gmail.com")
      return
    }
    if (!user_name) {
      error("Must Fill User Name")
      return
    } else localStorage.setItem("user", user_name)

    setLoading(true)
    const res = await fetch(BASE_URL + "users/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_name }),
    })

    if (!res.ok) {
      alert("Something went wrong")
      return
    }

    const { token } = await res.json()
    const resetLink = domain + `/reset-password/${token}`

    const res_reset = await fetch(BASE_URL + "sharie/sendresetemail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: email,
        text: "If you tried to reset password, Click here to reset your password: " + resetLink,
        user_name: user_name,
      }),
    })
    setLoading(false)

    if (!res_reset.ok) error("Failed to send email. Please try again.")
    else success("Email sent successfully!")
  }

  return (
    <T>
      <Box className={styles.login_box}>
        {/* Headline for Sharie */}
        <Box className={styles.headline_container}>
          <Icn
            label='logo'
            avatar={<Avatar src={ShariLogo} alt='Icon' className={"shari_logo"} />}
          />
          <Typography variant='h3' component='h1' className={styles.login_headline}>
            Sharie
          </Typography>
        </Box>

        <Box
          component='form'
          onSubmit={(e) => e.preventDefault()} // Handle submit logic here
          sx={{
            width: "100%",
            maxWidth: 400,
            padding: 3,
            backgroundColor: "background.paper",
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <TextField
            fullWidth
            label={t("User Name")}
            name='username'
            type='text'
            variant='outlined'
            margin='normal'
            required
            autoComplete='username'
            value={user_name || ""}
            autoFocus
            onChange={(e) => {
              handleUserNameChange(e)
            }}
          />
          <TextField
            fullWidth
            label={t("Password")}
            name='password'
            type={showPassword ? "text" : "password"}
            variant='outlined'
            margin='normal'
            autoComplete='current-password'
            required
            onKeyDown={inputKeyDown}
            onChange={(e) => {
              handlePasswordChange(e)
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    onClick={togglePasswordVisibility}
                    edge='end'
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                id='rememberMe'
                name='rememberMe'
                checked={remember_me}
                onChange={handleCheckboxChange}
              />
            }
            label={t("Remember Me")}
          />
          {loading ? (
            <Spinner />
          ) : (
            <Typography
              onClick={sendResetEmail}
              style={{
                cursor: "pointer",
                color: "blue",
                textDecoration: "underline",
              }}
            >
              {t("Forgot Password")}
            </Typography>
          )}
          <Button
            fullWidth
            variant='contained'
            color='primary'
            type='submit'
            onClick={doLogin}
            sx={{ marginTop: 2 }}
            disabled={loading}
          >
            Login
          </Button>
          <AlertError />
          <h1 className={styles.signup_button} title='go to sign up' onClick={goToSignup}>
            don't have an account yet? Click me
          </h1>
        </Box>
      </Box>
      {loading && <Spinner />}
    </T>
  )
}

export default Login
